import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { Helmet } from "react-helmet";
import { Config } from "../../Config";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import BannerImage from "../../assets/images/bannerAbout.jpg";
import AboutusItem from "../../components/AboutusItem/AboutusItem";
import BrandSlider from "../../components/BrandSlider/BrandSlider";
import Preloader from "../../components/Preloader/Preloader";
import "./AboutUs.scss";
import "./Responsive.scss";

const AboutUs = (props) => {
  const [preloader, setPreloader] = useState(false);
  const [aboutData, setAboutData] = useState([]);
  const [brandsSlider, setBrandsSlider] = useState([]);
  const user = useSelector((state) => state.user);
  const breadCrumbData = [
    { title: "خانه", link: "/" },
    { title: "درباره ما", link: "/aboutus" },
  ];

  useEffect(async () => {
    Config.pageUp();
    await getAllAbout();
  }, []);

  const getAllAbout = () => {
    // setPreloader(true);
    axios
      .get(
        "/AboutUs/Get",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setAboutData(result.data);
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(
        "/AboutUs/GetBrands",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setBrandsSlider(result.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
    // setPreloader(false);
  };

  return (
    <main className="aboutusWrapper mobile">
      <Helmet>
        <title>{Config.helmetTitle} | درباره ما</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      {preloader && <Preloader active={preloader} />}
      <BreadCrumb breadCrumbData={breadCrumbData} />
      <div className="aboutusContents">
        <div className="topBanner">
          <img className="aboutusImageBanner" src={BannerImage} alt="BannerImage" />
          {/* <p className="title">درباره ما</p> */}
        </div>
        <div className="desktop">
          <div className="aboutusItems">
            <AboutusItem aboutItemData={aboutData} />
          </div>
        </div>
        {brandsSlider.length > 0 && (
          <div className="ourPartnersSection">
            <div className="ourPartners">
              <div className="titles">
                <p className="title">همکاران ما</p>
                <p className="description">
                  اگرچه ما بسیار خوش شانس بوده ایم، اما می دانیم که هیچ چیز ارزشمندی بدون فداکاری واقعی حاصل نمی شود. با
                  تشکر ازشرکای تجاری، ما در مسیر خود به پیشرفت ادامه می دهیم.
                </p>
              </div>
              <BrandSlider
                infinite={brandsSlider.length > 4}
                slideCount={4}
                slideSpeed={4000}
                dots={false}
                autoplay={true}
                sldeToScroll={1}
                swipeToSlide={true}
                width="80%"
                height="150px"
                sliderData={brandsSlider}
              />
            </div>
          </div>
        )}
      </div>
    </main>
  );
};

export default React.memo(AboutUs);
